import { RefObject } from 'react'
import { Addresses } from 'stores/onboarding/types'
import { Properties } from 'types/onboarding'
import {
  InnskraningAnalyticsStepEnum,
  trackInnskraningEvent,
} from 'utils/onboarding/analytics'

const supportsNativeSmoothScroll =
  typeof document !== 'undefined' &&
  'scrollBehavior' in document.documentElement.style

const taktiakSignApiUrl =
  process.env.NEXT_PUBLIC_TAKTIKAL_SIGNIN_ENDPOINT || 'https://app.taktikal.is'

export interface payloadForIframeProps {
  name: string
  ssn: string
  properties: any
  mailinglist: boolean
  addresses: Addresses | undefined
  reference: string
  propertyDelivered: boolean | null
  boxAddress: string | null
  email: string
  phoneNumber: string
  offerType: string | null
  offer: string
  osNotkunarstadir: Properties
}

const scrollIntoView = (ref: RefObject<HTMLDivElement | undefined>) => {
  setTimeout(() => {
    const coordinates = ref.current?.getBoundingClientRect()
    console.log(coordinates)
    if (coordinates) {
      if (supportsNativeSmoothScroll) {
        window.scrollTo({ top: coordinates.top - 100, behavior: 'smooth' })
      } else {
        //ref.current?.scrollIntoView()
        window.scrollTo({ top: coordinates.top - 100 })
      }
    }
  }, 150)
}

interface getIframeProps {
  payload: payloadForIframeProps
  inViewPdf: boolean
  refPdf: React.MutableRefObject<HTMLDivElement | undefined>
  setIframeUrl: (value: React.SetStateAction<string>) => void
  setStep: (value: React.SetStateAction<1 | 2>) => void
  setErrorMessage: (value: React.SetStateAction<string>) => void
  setLoading: (value: React.SetStateAction<boolean>) => void
  captureError: (error: any) => void
}

export const getIFrameFromApi = async ({
  payload,
  inViewPdf,
  refPdf,
  setIframeUrl,
  setStep,
  setErrorMessage,
  setLoading,
  captureError,
}: getIframeProps) => {
  await fetch('/api/onboarding/sign', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status >= 400) {
        console.error(res)
        throw new Error('Error getting authenticating')
      }
      if (!inViewPdf) {
        scrollIntoView(refPdf)
      }
      return res.json()
    })
    .then((res) => {
      trackInnskraningEvent(
        InnskraningAnalyticsStepEnum.SIGNATURE_IFRAME_LOADED
      )

      setIframeUrl(
        `${taktiakSignApiUrl}/s/${res.processKey}/${res.key}?iframe=true&skipGreeting=true&showEndScreen=false&hideSignDocumentHeaderText=true`
      )
      setStep(2)
      setErrorMessage('')
    })
    .catch((error) => {
      captureError(error)
      // handle errors!
      setErrorMessage('Gat ekki náð sambandi við undirskriftarþjónustu.')
      console.error(error)
    })
    .finally(() => {
      setLoading(false)
    })
}
